module.exports = __webpack_public_path__ + "static/media/86s.5ea4b946.jpg";